{
  "action.addSticky": "Add Sticky Note",
  "action.alignHorizontal": "Align horizontally",
  "action.alignVertical": "Align vertically",
  "action.arrange": "Arrange in Region",
  "action.art": "Art",
  "action.assign": "Assign",
  "action.backlogBoard": "ART Backlog Board",
  "action.boardConfig": "Board Configuration",
  "action.breakdown": "Breakdown Board",
  "action.bulk.itemsSelected": "1 item selected. | {count} items selected.",
  "action.bulkDelete.blockedAlmConfig.description": "{almName}-linked stickies can only be deleted in {almName}.",
  "action.bulkDelete.blockedAlmConfig.title": "Synced items that will not be deleted",
  "action.bulkDelete.blockedAlmMulti.description": "Stickies synced to {almName} must be deleted individually.",
  "action.bulkDelete.blockedAlmMulti.title": "Synced items that will not be deleted",
  "action.bulkDelete.blockedMirror.description": "Mirrored items can only be deleted on the origin board.",
  "action.bulkDelete.blockedMirror.title": "Mirrored items that will not be deleted",
  "action.bulkDelete.primary": "Delete 1 Item | Delete {count} Items",
  "action.bulkDelete.subtitlePartial": "Only {count} can be deleted.",
  "action.bulkDelete.title": "Delete Sticky Notes",
  "action.bulkDelete.willBeDeletedHeading": "Items to be deleted permanently",
  "action.bulkRemove.blockedOrigin.description": "Stickies created on this board must be deleted.",
  "action.bulkRemove.blockedOrigin.title": "Items that will not be removed",
  "action.bulkRemove.blockedUnplannable.description": "Stickies from the Work Item Selector must be unplanned.",
  "action.bulkRemove.blockedUnplannable.title": "Work Items that will not be removed",
  "action.bulkRemove.primary": "Remove 1 Item | Remove {count} Items",
  "action.bulkRemove.subtitlePartial": "Only {count} can be removed.",
  "action.bulkRemove.title": "Remove Sticky Notes",
  "action.bulkRemove.willBeRemovedHeading": "Items to be removed from this board",
  "action.bulkUnplan.blockedNotUnplannable.description": "Only stickies from the Work Item Selector can be unplanned.",
  "action.bulkUnplan.blockedNotUnplannable.title": "Items that will not be unplanned",
  "action.bulkUnplan.primary": "Unplan 1 Item | Unplan {count} Items",
  "action.bulkUnplan.subtitlePartial": "Only {count} can be unplanned.",
  "action.bulkUnplan.title": "Unplan Work Items",
  "action.bulkUnplan.willBeUnplannedBanner": "{count} work items will be removed from this iteration and returned to the Work Item Selector.",
  "action.bulkUnplan.willBeUnplannedHeading": "Items to be unplanned",
  "action.canvases": "Canvases",
  "action.confidenceVote": "Confidence Vote",
  "action.deleteAlmSticky.deletionBlocked": "This sticky note can only be deleted in {almName}.",
  "action.deleteAlmSticky.deletionBlocked.config": "Deletion is disabled for {almName}-synced stickies",
  "action.deleteAlmSticky.deletionBlocked.multi": "Multiple {almName}-synced stickies cannot be deleted at once. Select them individually to delete.",
  "action.deleteAlmSticky.iterationName.ac": "iteration",
  "action.deleteAlmSticky.iterationName.ado": "iteration path one level up",
  "action.deleteAlmSticky.iterationName.jira": "sprint",
  "action.deleteAlmSticky.willAlsoBeDeleted": "{almId} will also be deleted in {almName}.",
  "action.deleteSticky": "Delete Sticky Note",
  "action.deleteSticky.description": "Are you sure you want to delete this sticky note? This action cannot be undone. | Are you sure you want to delete these sticky notes? This action cannot be undone.",
  "action.distributeHorizontal": "Distribute horizontally",
  "action.distributeVertical": "Distribute vertically",
  "action.duplicate": "Duplicate",
  "action.executionMode": "Execution Mode",
  "action.facilitation": "Facilitation",
  "action.lineTool": "Draw lines",
  "action.lineup": "Line up in a grid",
  "action.linkMultiple": "Link",
  "action.messenger": "Help",
  "action.mirrorMultiple": "Mirror",
  "action.moveSticky": "Move Sticky Note",
  "action.next": "Next",
  "action.objectivesBoard": "ART PI Objectives",
  "action.panMode": "Pan Mode",
  "action.paste": "Paste",
  "action.planMode": "Planning Mode",
  "action.pointer": "Pointer Trail",
  "action.previous": "Previous",
  "action.programBoard": "ART Planning Board",
  "action.programMetrics": "ART Metrics",
  "action.removeSticky": "Remove Sticky Note | Remove {count} Sticky Notes",
  "action.removeSticky.description": "Are you sure you want to remove this sticky note? It will only be removed from this board. | Are you sure you want to remove these sticky notes? They will only be removed from this board.",
  "action.riskBoard": "ART PI Risks",
  "action.scaleStickies": "Scale stickies",
  "action.search": "Search",
  "action.searchArts": "Search ARTs",
  "action.searchPlaceholder": "Sticky text / ALM ID",
  "action.searchTeams": "Search Teams",
  "action.searchUsers": "Search Users",
  "action.share": "Share",
  "action.shiftMenu": "Shift navigation to the other side",
  "action.showOverview": "Show overview",
  "action.solutionBacklogBoard": "Solution Backlog Board",
  "action.solutionBoard": "Solution Planning Board",
  "action.stack": "Stack",
  "action.stickyMagnify": "Sticky Magnify",
  "action.switchWorkMode": "Switch to {mode}",
  "action.team": "Team",
  "action.teamBoard": "Team Board",
  "action.teamMetrics": "Team Metrics",
  "action.teamObjectives": "Objectives",
  "action.timer": "Timer",
  "action.toggleWorkMode": "Switch Working Modes",
  "action.undoSelectionAction": "Undo {action} {count} stickies",
  "action.unplanSticky.description": "Unplanning will remove the work item from the iteration. It will still be visible in the Work Item Selector.",
  "action.unplanSticky.title": "Unplan Work Item",
  "actionMenu.enabling": "Enabling team",
  "actionMenu.enabling.ariaLabel": "Enabling team: {team}",
  "actionMenu.mirrored": "Mirrored",
  "actionMenu.organize": "Organize",
  "actionMenu.team.unassigned": "Unassigned",
  "actionMenu.wsjf": "WSJF: {value}",
  "actionMenu.wsjf.readonly": "WSJF: {value}. The WSJF value cannot be modified here.",
  "actions.art": "ART",
  "actions.selectProject": "Select a project",
  "actions.selectStickyType": "Select a sticky note type",
  "actions.wsjf": "WSJF",
  "actions.wsjfWarning": "The WSJF value cannot be modified here.",
  "almSync.tooltip": "Connection to the ALM tool failed. Click to get more information and ability to fix it.",
  "almsync.disconnected": "{almType} Disconnected",
  "almsync.resync": "Resyncing",
  "almsync.stopped": "{almType} Sync Stopped",
  "appZoom.zoom": "Zoom",
  "artModal.title": "Assign stickies to an ART",
  "assignee.cannotSet": "The assignee can currently only be changed in {almType}.",
  "assignee.unknownAlmUser": "Unknown {almType} user",
  "assignee.userNotMappedInAlm": "This piplanning.io user is not mapped to a {almType} user. The assignee will not be updated in {almType}.",
  "assignee.userNotMappedInPip": "The user assigned to this issue in {almType} is not mapped to a piplanning.io user. Their name cannot be shown.",
  "background.businessModelCanvasAdaptionCCLicense": "{canvasName} is adapted from The Business Model Canvas (https://www.strategyzer.com/canvas/business-model-canvas) and is licensed under the Creative Commons Attribution-Share Alike 3.0 Unported License.",
  "background.by": "by {name}",
  "background.createdCredits": "created with passion in",
  "background.day": "Day {day}",
  "background.risks": "Risks",
  "background.saiAdapted": "{name} is adapted from \"{originalName}\" provided by Scaled Agile, Inc. ({url})",
  "background.teamNr": "Team {0}",
  "background.timeZone": "Time Zone {timeZoneNumber}",
  "backgroundAgenda.agenda2x2": "Agenda 2x2",
  "backgroundAgenda.agenda2x3": "Agenda 2x3",
  "backgroundAgenda.agenda2x5": "Agenda 2x5",
  "backgroundAgenda.agenda3x2": "Agenda 3x2",
  "backgroundAgenda.agenda3x3": "Agenda 3x3",
  "backgroundAgenda.agenda3x5": "Agenda 3x5",
  "backgroundArtTracks.accelerate": "Accelerate",
  "backgroundArtTracks.aftercare": "Aftercare",
  "backgroundArtTracks.artTracks": "ART Tracks",
  "backgroundArtTracks.firstPi": "First PI",
  "backgroundArtTracks.identify": "Identify",
  "backgroundArtTracks.inputFunnel": "Input Funnel",
  "backgroundArtTracks.launch": "Launch",
  "backgroundArtTracks.preparation": "Preparation",
  "backgroundArtTracks.secondPi": "Second PI",
  "backgroundArtTracks.stations": "Stations",
  "backgroundArtTracks.transformation": "Transformation Backlog",
  "backgroundBusinessModel.businessModelCanvas": "Business Model Canvas",
  "backgroundBusinessModel.businessModelCanvasNote": "The Business model canvas is created by strategyzer and licensed under the Creative Commons Attribution-Share Alike 3.0 Unported license. To view a copy of this license, visit {url}.",
  "backgroundBusinessModel.channels": "Channels",
  "backgroundBusinessModel.costStructure": "Cost Structure",
  "backgroundBusinessModel.customerRelationships": "Customer Relationships",
  "backgroundBusinessModel.customerSegments": "Customer Segments",
  "backgroundBusinessModel.keyActivities": "Key Activities",
  "backgroundBusinessModel.keyPartners": "Key Partners",
  "backgroundBusinessModel.keyResources": "Key Resources",
  "backgroundBusinessModel.revenueStreams": "Revenue Streams",
  "backgroundBusinessModel.valuePropositions": "Value Propositions",
  "backgroundChecklist.checklist": "Checklist",
  "backgroundConfidenceVoting.confidenceVote": "Confidence Vote - Fist of Five",
  "backgroundCustomerJourney.customerBackStory": "customer back-story",
  "backgroundCustomerJourney.customerJourneyMap": "Customer Journey Map",
  "backgroundCustomerJourney.opportunityImprovePotential": "Opportunities / Improvement / Potential",
  "backgroundCustomerJourney.painPoints": "Pain Points",
  "backgroundCustomerJourney.persona": "Persona",
  "backgroundCustomerJourney.thinkingAndFeeling": "Thinking & Feeling",
  "backgroundEarlyToMature.early": "Early",
  "backgroundEarlyToMature.established": "Established",
  "backgroundEarlyToMature.failing": "Failing",
  "backgroundEarlyToMature.mature": "Mature",
  "backgroundEarlyToMature.name": "Early to Mature",
  "backgroundEarlyToMature.successful": "Successful",
  "backgroundEarlyToMature.working": "Working",
  "backgroundEffortMatrix.costOfDelay": "Cost of Delay",
  "backgroundEffortMatrix.costOfDelayEffortMatrix": "Cost of Delay x Effort Matrix",
  "backgroundEffortMatrix.effortDuration": "Effort (Duration)",
  "backgroundEmpathyRetro.actions": "Actions",
  "backgroundEmpathyRetro.appreciations": "Appreciations",
  "backgroundEmpathyRetro.name": "Empathy Retrospective",
  "backgroundEmpathyRetro.puzzles": "Puzzles",
  "backgroundEmpathyRetro.wishes": "Wishes",
  "backgroundGoldenCircle.goldenCircle": "Golden Circle",
  "backgroundGoldenCircle.how": "HOW",
  "backgroundGoldenCircle.what": "WHAT",
  "backgroundGoldenCircle.why": "WHY",
  "backgroundGrid510.name": "Grid 5x10",
  "backgroundImpactEffortMatrix.fillInJobs": "Fill In Jobs",
  "backgroundImpactEffortMatrix.highEffort": "High Effort",
  "backgroundImpactEffortMatrix.highImpact": "High Impact",
  "backgroundImpactEffortMatrix.impactEffortMatrix": "Impact Effort Matrix",
  "backgroundImpactEffortMatrix.lowEffort": "Low Effort",
  "backgroundImpactEffortMatrix.lowImpact": "Low Impact",
  "backgroundImpactEffortMatrix.majorProjects": "Major Projects",
  "backgroundImpactEffortMatrix.notWorthIt": "Not Worth It",
  "backgroundImpactEffortMatrix.quickWins": "Quick Wins!",
  "backgroundIshikawa.cause": "Cause",
  "backgroundIshikawa.effect": "Effect",
  "backgroundIshikawa.ishikawaDiagram": "Ishikawa Diagram",
  "backgroundKeyTopics.keyTopics": "Key Topics",
  "backgroundKeyTopics.topicNr": "Topic {0}",
  "backgroundLeanCanvas.channels": "Channels",
  "backgroundLeanCanvas.channelsList": "List your path to customers (inbound or outbound).",
  "backgroundLeanCanvas.costStructure": "Cost Structure",
  "backgroundLeanCanvas.costStructureList": "List your fixed and variable costs.",
  "backgroundLeanCanvas.customerSegments": "Customer Segments",
  "backgroundLeanCanvas.customerSegmentsList": "List your target customers and users.",
  "backgroundLeanCanvas.customerView": "Customer View",
  "backgroundLeanCanvas.earlyAdopters": "Early Adopters",
  "backgroundLeanCanvas.earlyAdoptersList": "List the characteristics of your ideal customers.",
  "backgroundLeanCanvas.existingAlternatives": "Existing Alternatives",
  "backgroundLeanCanvas.existingAlternativesList": "List how these problems are solved today.",
  "backgroundLeanCanvas.highlevelConcept": "High-Level Concept",
  "backgroundLeanCanvas.highlevelConceptList": "List your X for Y analogy e.g. YouTube = Flickr for videos.",
  "backgroundLeanCanvas.keyMetrics": "Key Metrics",
  "backgroundLeanCanvas.keyMetricsList": "List the key numbers that tell you how your business is doing.",
  "backgroundLeanCanvas.leanCanvas": "Lean Canvas",
  "backgroundLeanCanvas.marketView": "Market View",
  "backgroundLeanCanvas.problem": "Problem",
  "backgroundLeanCanvas.problemsList": "List your top 1-3 problems.",
  "backgroundLeanCanvas.productView": "Product View",
  "backgroundLeanCanvas.revenueStreams": "Revenue Streams",
  "backgroundLeanCanvas.revenueStreamsList": "List your sources of revenue.",
  "backgroundLeanCanvas.solution": "Solution",
  "backgroundLeanCanvas.solutionsList": "Outline a possible solution for each problem.",
  "backgroundLeanCanvas.unfairAdvantage": "Unfair Advantage",
  "backgroundLeanCanvas.unfairAdvantageList": "Something that cannot easily be bought or copied.",
  "backgroundLeanCanvas.uniqueValueProposition": "Unique Value Proposition",
  "backgroundLeanCanvas.uniqueValuePropositionList": "Single, clear, compelling message that states why you are different and worth paying attention.",
  "backgroundMagicQuadrant.name": "Magic Quadrants",
  "backgroundMatrix.name": "Matrix Diagram",
  "backgroundMountainClimber.climbing": "Climbing",
  "backgroundMountainClimber.climbingText": "Progress, where to keep going",
  "backgroundMountainClimber.compass": "Compass",
  "backgroundMountainClimber.falling": "Falling",
  "backgroundMountainClimber.fallingText": "Things to watch out for, Risks",
  "backgroundMountainClimber.name": "Mountain Climber",
  "backgroundMountainClimber.start": "Things to start doing",
  "backgroundMountainClimber.stop": "Things to stop doing",
  "backgroundMountainClimber.storm": "Storm",
  "backgroundMountainClimber.stormText": "Challenges, What's not clear",
  "backgroundMountainClimber.sun": "Sun",
  "backgroundMountainClimber.sunText": "Success and what's going great",
  "backgroundMountainClimber.weeds": "Weeds",
  "backgroundParking.name": "Parking Lot",
  "backgroundPiplanningProduct.art": "ART",
  "backgroundPiplanningProduct.collaborate": "Collaborate",
  "backgroundPiplanningProduct.execute": "Execute & Track",
  "backgroundPiplanningProduct.facilitate": "Facilitate",
  "backgroundPiplanningProduct.management": "Product Management & Forecast",
  "backgroundPiplanningProduct.plan": "Plan",
  "backgroundPiplanningProduct.portfolio": "Portfolio",
  "backgroundPiplanningProduct.solution": "Solution",
  "backgroundPiplanningProduct.team": "Team",
  "backgroundPiplanningProduct.title": "piplanning.io Product",
  "backgroundPlusMinusDelta.delta": "Delta",
  "backgroundPlusMinusDelta.minus": "Minus",
  "backgroundPlusMinusDelta.name": "Plus Minus Delta",
  "backgroundPlusMinusDelta.plus": "Plus",
  "backgroundPortfolio.budget": "Budget",
  "backgroundPortfolio.channels": "Channels",
  "backgroundPortfolio.costStructure": "Cost Structure",
  "backgroundPortfolio.customerRelationships": "Customer Relationships",
  "backgroundPortfolio.customers": "Customers",
  "backgroundPortfolio.keyActivities": "Key Activities",
  "backgroundPortfolio.keyPartners": "Key Partners",
  "backgroundPortfolio.keyResources": "Key Resources",
  "backgroundPortfolio.kpiRevenue": "KPI / Revenue",
  "backgroundPortfolio.portfolioCanvas": "Portfolio Canvas",
  "backgroundPortfolio.revenueStreams": "Revenue Streams",
  "backgroundPortfolio.solutions": "Solutions",
  "backgroundPortfolio.valuePropositions": "Value Propositions",
  "backgroundPortfolio.valueStreams": "Value Streams",
  "backgroundPortfolioRoadmap.firstHalfYear": "H1",
  "backgroundPortfolioRoadmap.milestones": "Milestones",
  "backgroundPortfolioRoadmap.portfolioRoadmap": "Portfolio Roadmap",
  "backgroundPortfolioRoadmap.portfolioRoadmap2": "Portfolio Roadmap 2",
  "backgroundPortfolioRoadmap.quarter": "Q{0}",
  "backgroundPortfolioRoadmap.secondHalfYear": "H2",
  "backgroundPortfolioRoadmap.year": "Y{0}",
  "backgroundProblemSolving.decisions": "Decisions",
  "backgroundProblemSolving.measures": "Measures",
  "backgroundProblemSolving.name": "Problem Solving",
  "backgroundProblemSolving.possibleSolutions": "Possible Solutions",
  "backgroundProblemSolving.problems": "Problems",
  "backgroundRetro.continueDoing": "Continue Doing",
  "backgroundRetro.retrospective": "Retrospective",
  "backgroundRetro.startDoing": "Start Doing",
  "backgroundRetro.stopDoing": "Stop Doing",
  "backgroundRoamKanban.accepted": "Accepted",
  "backgroundRoamKanban.inProgress": "In Progress",
  "backgroundRoamKanban.mitigated": "Mitigated",
  "backgroundRoamKanban.owned": "Owned",
  "backgroundRoamKanban.ready": "Ready",
  "backgroundRoamKanban.resolved": "Resolved",
  "backgroundRoamKanban.review": "Review",
  "backgroundRoamKanban.riskBacklog": "Risk Backlog",
  "backgroundRoamKanban.roamKanban": "ROAM | Kanban",
  "backgroundRootCause.biggest": "#{item} Biggest Root-Cause",
  "backgroundRootCause.environment": "Environment",
  "backgroundRootCause.improvement": "#{item} Identify Improvement Backlog Items",
  "backgroundRootCause.people": "People",
  "backgroundRootCause.problem": "#{item} Original Problem",
  "backgroundRootCause.process": "Process",
  "backgroundRootCause.program": "Program",
  "backgroundRootCause.restate": "#{item} Restate Problem",
  "backgroundRootCause.rootCause": "#{item} Root-Cause Analysis",
  "backgroundRootCause.solutions": "#{item} Brainstorm Solutions",
  "backgroundRootCause.title": "Root-Cause Analysis",
  "backgroundRootCause.tools": "Tools",
  "backgroundSailboat.name": "Sailboat",
  "backgroundSos.access": "Do you have access to the team members and stakeholders you need?",
  "backgroundSos.allOk": "Are all your NOs above YES now?",
  "backgroundSos.architecture": "Do you understand the architectural context, and who to go to for questions?",
  "backgroundSos.capacity": "Have you finished allocating capacity (if necessary) to maintenance in your Iteration?",
  "backgroundSos.completeDraft": "Do you anticipate completing your draft plan?",
  "backgroundSos.completePlan": "Do you anticipate completing your final plan?",
  "backgroundSos.day1": "Scrum of Scrum - Day 1",
  "backgroundSos.day2": "Scrum of Scrum - Day 2",
  "backgroundSos.devops": "Do you understand the role of the System Team and DevOps, and who to go to for questions?",
  "backgroundSos.discussPO": "Are you discussing trade-offs and conflicting priorities with your business owners?",
  "backgroundSos.discussSM": "Is there anything you need to discuss with other Scrum Masters? If so, stay for the 'Meet After'",
  "backgroundSos.draftReady": "Draft Plan Readiness",
  "backgroundSos.estimateStories": "Are you identifying and estimating stories?",
  "backgroundSos.feedback": "Do you understand how the management team feedback affects your team?",
  "backgroundSos.finalReady": "Final Plan Readiness",
  "backgroundSos.finalizeObjectives": "Are your PI Objectives, Uncommitted Objectives, and business value finalized?",
  "backgroundSos.getStarted": "Getting Started",
  "backgroundSos.hardDates": "Have hard dates been identified and represented on the ART planning board?",
  "backgroundSos.havePOSM": "Do you have a Product Owner and Scrum Master?",
  "backgroundSos.identifyCapacity": "Have you identified the capacity for each Iteration in your PI?",
  "backgroundSos.identifyDependencies": "Have you identified any dependencies?",
  "backgroundSos.identifyHardDates": "Are you confident you have identified all hard dates based on the latest feedback and represented them on the ART planning board?",
  "backgroundSos.iterationStory": "Is Iteration story level planning in process?",
  "backgroundSos.iterations": "Have you planned all Iterations for your PI?",
  "backgroundSos.knowTeam": "Do you know who your team is for the whole PI?",
  "backgroundSos.latestRisks": "Are you confident you have identified your ART PI risks based on the latest feedback?",
  "backgroundSos.mitigateRisks": "Are your team risks mitigated?",
  "backgroundSos.moreCapacity": "Did you consider whether you need to allocate capacity to maintenance in your Iterations?",
  "backgroundSos.objectives": "Have you begun writing your PI Objectives?",
  "backgroundSos.objectivesProgress": "Objectives Progress",
  "backgroundSos.planningProgress": "Planning Progress",
  "backgroundSos.presentPlan": "Are you ready to present your final plan?",
  "backgroundSos.prioritizeObjectives": "Have your business owners begun prioritizing your PI Objectives and Uncommitted Objectives?",
  "backgroundSos.progressCheckin": "Progress Check-in",
  "backgroundSos.radiator1": "SoS Radiator Day 1",
  "backgroundSos.radiator2": "SoS Radiator Day 2",
  "backgroundSos.release": "Have you confirmed whether or not there is an opportunity to release before the end of the PI?",
  "backgroundSos.remainingDependencies": "Are you confident you have identified remaining dependencies based on the latest feedback and have you represented them on the ART planning board?",
  "backgroundSos.remainingRisks": "Have you identified remaining team and ART PI risks?",
  "backgroundSos.removeBlockings": "Have all blocking issues which are impacting planning been removed?",
  "backgroundSos.replanIterations": "Have you replanned all Iterations in the PI as necessary?",
  "backgroundSos.representDependencies": "Are your dependencies represented on the ART planning board?",
  "backgroundSos.requirements": "Do you understand the planning requirements?",
  "backgroundSos.resolveDependencies": "Have you begun resolving dependencies with other teams?",
  "backgroundSos.reviewRisks": "Are your ART PI risks ready for review ('ROAM'ing)?",
  "backgroundSos.revisedObjectives": "Are your revised PI Objectives and Uncommitted Objectives clear, legible, succinct, and more measurable?",
  "backgroundSos.risks": "Are you identifying team and ART PI risks?",
  "backgroundSos.setup": "Is your working space setup?",
  "backgroundSos.shared": "Do you understand which resources are shared (e.g. UX, Training and Documentation) and who to go to for questions?",
  "backgroundSos.smartObjectives": "Are your PI Objectives and Uncommitted Objectives for the PI clear, legible, succinct, and measurable (as per SMART Objectives)?",
  "backgroundSos.stories": "Have you identified most of your stories?",
  "backgroundSos.vision": "Do you understand (and can you find) the vision that drives your backlog?",
  "backgroundSosSync.capacity": "Have you defined the capacity for each iteration in the PI?",
  "backgroundSosSync.dependencies": "Have you begun resolving dependencies with other teams?",
  "backgroundSosSync.discussBO": "Are you discussing trade-offs and conflicting priorities with your Business Owners?",
  "backgroundSosSync.discussSM": "Is there anything you need to discuss with other Scrum Masters? If so, stay for the meet-after.",
  "backgroundSosSync.objectives": "Will you be ready to start writing PI Objectives in the next 15 minutes?",
  "backgroundSosSync.risks": "Have you identified any ART PI risks?",
  "backgroundSosSync.stories": "Have you identified most of the Stories for the first two iterations and begun estimating?",
  "backgroundSosSync.title": "Scrum of Scrum Sync Questions",
  "backgroundSpeedCard.engine": "Engine",
  "backgroundSpeedCard.engineText": "What powers us forward",
  "backgroundSpeedCard.finish": "Finish Line",
  "backgroundSpeedCard.finishText": "What's motivating us? How do we celebrate",
  "backgroundSpeedCard.name": "Speed Car",
  "backgroundSpeedCard.parachute": "Parachute",
  "backgroundSpeedCard.parachuteText": "What's slowing us down",
  "backgroundSpeedCard.stop": "Stop Sign",
  "backgroundSpeedCard.stopText": "What do we need to stop doing",
  "backgroundStarfish.keep": "Keep",
  "backgroundStarfish.less": "Less",
  "backgroundStarfish.more": "More",
  "backgroundStarfish.name": "Star Fish",
  "backgroundStarfish.start": "Start",
  "backgroundStarfish.stop": "Stop",
  "backgroundSwot.opportunities": "Opportunities",
  "backgroundSwot.strengths": "Strengths",
  "backgroundSwot.swotAnalysis": "SWOT Analysis",
  "backgroundSwot.threats": "Threats",
  "backgroundSwot.weaknesses": "Weaknesses",
  "backgroundSwotTows.eval": "SWOT / TOWS Analysis (Evaluation)",
  "backgroundSwotTows.feasibility": "Feasibility",
  "backgroundSwotTows.impact": "Impact",
  "backgroundSwotTows.notes": "Notes",
  "backgroundSwotTows.opportunities": "External Opportunities",
  "backgroundSwotTows.probability": "Probability",
  "backgroundSwotTows.so": "SO",
  "backgroundSwotTows.soNote": "SO: How can your strengths be used to exploit and maximize opportunities?",
  "backgroundSwotTows.st": "ST",
  "backgroundSwotTows.stNote": "ST: How can you apply your strengths to overcome present and potential threats?",
  "backgroundSwotTows.strengths": "Internal Strengths",
  "backgroundSwotTows.threats": "External Threats",
  "backgroundSwotTows.title": "SWOT / TOWS Analysis",
  "backgroundSwotTows.weaknesses": "Internal Weaknesses",
  "backgroundSwotTows.wo": "WO",
  "backgroundSwotTows.woNote": "WO: How can your opportunities be leveraged to overcome weaknesses",
  "backgroundSwotTows.wt": "WT",
  "backgroundSwotTows.wtNote": "WT: How can you minimize weaknesses and avoid threats?",
  "backgroundTodoProgressDone.done": "Done",
  "backgroundTodoProgressDone.inProgress": "In Progress",
  "backgroundTodoProgressDone.name": "To Do - In Progress - Done",
  "backgroundTodoProgressDone.todo": "To Do",
  "backgroundUserStoryMap.highlevelActivities": "High Level Activities",
  "backgroundUserStoryMap.releaseXy": "Release x.y",
  "backgroundUserStoryMap.userStoryMap": "User Story Map",
  "backgroundValueStream.budget": "Budget",
  "backgroundValueStream.channels": "Channels",
  "backgroundValueStream.customerRelationships": "Customer Relationships",
  "backgroundValueStream.customerSegments": "Customer Segments",
  "backgroundValueStream.economy": "Economic Framework",
  "backgroundValueStream.for": "For...",
  "backgroundValueStream.isA": "Is a...",
  "backgroundValueStream.operational": "Operational Value Stream Supported",
  "backgroundValueStream.ourSolution": "Our Solution...",
  "backgroundValueStream.people": "People and Locations",
  "backgroundValueStream.proposition": "Value Propositions",
  "backgroundValueStream.revenue": "KPI / Revenue",
  "backgroundValueStream.roles": "Key Roles",
  "backgroundValueStream.solutionContext": "Solution Context",
  "backgroundValueStream.solutions": "Solutions",
  "backgroundValueStream.suppliers": "ARTs and Suppliers",
  "backgroundValueStream.that": "That...",
  "backgroundValueStream.the": "The...",
  "backgroundValueStream.title": "Value Stream Canvas",
  "backgroundValueStream.unlike": "Unlike...",
  "backgroundValueStream.who": "Who...",
  "backgroundValueStreamIdent.customerValue": "Customer Value",
  "backgroundValueStreamIdent.developmentValue": "Development Value Streams",
  "backgroundValueStreamIdent.operationalValue": "Operational Value Stream",
  "backgroundValueStreamIdent.people": "People",
  "backgroundValueStreamIdent.systems": "Systems",
  "backgroundValueStreamIdent.valueStreamIdentification": "Value Stream Identification",
  "backgroundWelcome.followGuide": "Follow the numbers that guide you through piplanning.io",
  "backgroundWelcome.learnMaster": "Learn more and master piplanning.io",
  "backgroundWelcome.startTour": "Click the link on the sticky note to start the tour",
  "backgroundWorkingAgreement.codeOfConduct": "Code of Conduct",
  "backgroundWorkingAgreement.communicationChannels": "Communication Channels",
  "backgroundWorkingAgreement.linkTypes": "Link Types",
  "backgroundWorkingAgreement.stickers": "Stickers",
  "backgroundWorkingAgreement.stickyTypes": "Sticky Types",
  "backgroundWorkingAgreement.workflows": "Workflows",
  "backgroundWorkingAgreement.workingAgreement": "Working Agreement",
  "backgroundWorldMap.adisAbaba": "Adis Ababa",
  "backgroundWorldMap.algiers": "Algiers",
  "backgroundWorldMap.anchorage": "Anchorage",
  "backgroundWorldMap.astana": "Astana",
  "backgroundWorldMap.atlantis": "Atlantis",
  "backgroundWorldMap.auckland": "Auckland",
  "backgroundWorldMap.bangkok": "Bangkok",
  "backgroundWorldMap.beijing": "Beijing",
  "backgroundWorldMap.bogota": "Bogota",
  "backgroundWorldMap.brasilia": "Brasilia",
  "backgroundWorldMap.buenosAires": "Buenos Aires",
  "backgroundWorldMap.cairo": "Cairo",
  "backgroundWorldMap.capeTown": "Cape Town",
  "backgroundWorldMap.caracas": "Caracas",
  "backgroundWorldMap.chicago": "Chicago",
  "backgroundWorldMap.dallas": "Dallas",
  "backgroundWorldMap.denver": "Denver",
  "backgroundWorldMap.edmonton": "Edmonton",
  "backgroundWorldMap.hoChiMinhCity": "Ho Chi Minh City",
  "backgroundWorldMap.hongKong": "Hong Kong",
  "backgroundWorldMap.irkutsk": "Irkutsk",
  "backgroundWorldMap.istanbul": "Istanbul",
  "backgroundWorldMap.jakarta": "Jakarta",
  "backgroundWorldMap.johannesburg": "Johannesburg",
  "backgroundWorldMap.khartoum": "Khartoum",
  "backgroundWorldMap.kinshasa": "Kinshasa",
  "backgroundWorldMap.kisangani": "Kisangani",
  "backgroundWorldMap.lagos": "Lagos",
  "backgroundWorldMap.lima": "Lima",
  "backgroundWorldMap.london": "London",
  "backgroundWorldMap.losAngeles": "Los Angeles",
  "backgroundWorldMap.madrid": "Madrid",
  "backgroundWorldMap.magadan": "Magadan",
  "backgroundWorldMap.manaus": "Manaus",
  "backgroundWorldMap.melbourne": "Melbourne",
  "backgroundWorldMap.mexicoCity": "Mexico City",
  "backgroundWorldMap.moscow": "Moscow",
  "backgroundWorldMap.nairobi": "Nairobi",
  "backgroundWorldMap.name": "World Map",
  "backgroundWorldMap.newDelhi": "New Delhi",
  "backgroundWorldMap.newYork": "New York",
  "backgroundWorldMap.novosibirsk": "Novosibirsk",
  "backgroundWorldMap.paris": "Paris",
  "backgroundWorldMap.perth": "Perth",
  "backgroundWorldMap.rioDeJaneiro": "Rio de Janeiro",
  "backgroundWorldMap.riyadh": "Riyadh",
  "backgroundWorldMap.rome": "Rome",
  "backgroundWorldMap.saintPetersburg": "Saint Petersburg",
  "backgroundWorldMap.samara": "Samara",
  "backgroundWorldMap.santiago": "Santiago",
  "backgroundWorldMap.saoPaulo": "Sao Paulo",
  "backgroundWorldMap.seoul": "Seoul",
  "backgroundWorldMap.shanghai": "Shanghai",
  "backgroundWorldMap.singapore": "Singapore",
  "backgroundWorldMap.sydney": "Sydney",
  "backgroundWorldMap.taipei": "Taipei",
  "backgroundWorldMap.tehran": "Tehran",
  "backgroundWorldMap.tokyo": "Tokyo",
  "backgroundWorldMap.toronto": "Toronto",
  "backgroundWorldMap.vancouver": "Vancouver",
  "backgroundWorldMap.washington": "Washington, D.C.",
  "backgroundWorldMap.winnipeg": "Winnipeg",
  "backgroundWorldMap.yekaterinburg": "Yekaterinburg",
  "backlogBoard.confirmManualUpdate": "Synchronize the stickies with {almType}",
  "backlogBoard.programBacklog": "ART Backlog",
  "backlogBoard.solutionBacklog": "Solution Backlog",
  "backlogBoard.stickyOverwrite": "Stickies with ALM-Key will be overwritten by the state of {almType}.",
  "backlogSync.failedSync": "Could not synchronize the backlog. Please try again. {errorMessage}",
  "backlogSync.timeout": "Synchronizing takes a long time. Continuing in the background.",
  "board.backlog": "ART Backlog Board",
  "board.backlog.kanban": "ART Backlog Board Kanban",
  "board.backlog.long": "ART Backlog {art}",
  "board.backlog.nav": "Backlog",
  "board.biggerCards": "Bigger Sticky Notes",
  "board.flex": "Canvas",
  "board.flex.long": "Collaboration Canvas {name}",
  "board.objectives": "ART PI Objectives",
  "board.objectives.long": "Objectives {art}",
  "board.objectives.nav": "Objectives",
  "board.program": "ART Planning Board",
  "board.program.kanban": "ART Planning Board Kanban",
  "board.program.long": "ART Planning {art}",
  "board.program.nav": "Planning",
  "board.reloadKanban": "Reload kanban configuration",
  "board.risk": "ART PI Risks",
  "board.risk.long": "ART PI Risk {art}",
  "board.risk.nav": "Risks",
  "board.smallerCards": "Smaller Sticky Notes",
  "board.solution": "Solution Planning Board",
  "board.solution.kanban": "Solution Planning Board Kanban",
  "board.solution.long": "Solution",
  "board.solution.nav": "Planning",
  "board.solutionBacklog": "Solution Backlog Board",
  "board.solutionBacklog.kanban": "Solution Backlog Board Kanban",
  "board.solutionBacklog.long": "Solution Backlog",
  "board.team": "Team Board",
  "board.team.long": "Team {team}",
  "board.team.nav": "Team",
  "boardBase.arrangeStickies": "Arrange stickies",
  "boardBase.arrangeStickyPrompt": "Arrange all stickies in {boardLocation}",
  "boardBase.reorderBlurb": "This will reorder the stickies into a grid formation. This cannot be undone!",
  "boardBase.reorderBlurb.imgAlt": "Animation showing stickies being reordered into a grid.",
  "boardBase.reorderTip": "Alternative: Select the stickies and from the Organize menu {menu} choose 'Arrange in Region' {action}.",
  "boardConfig.title": "{board} Configuration",
  "boardDiff.boardTitle": "Board History",
  "boardDiff.compare.description": "See how the sticky notes on this board have changed within the time frame above.",
  "boardDiff.compare.title": "Compare",
  "boardDiff.dateCustom": "Custom {date} ({from} - {to})",
  "boardDiff.dateCustomTrigger": "Custom Dates",
  "boardDiff.dateRange": "Date Range",
  "boardDiff.dates": "{from} - {to}",
  "boardDiff.deletedCardText": "{cardName} (deleted)",
  "boardDiff.last24Hours": "Last 24 Hours",
  "boardDiff.lastWorkday": "Since last workday",
  "boardDiff.log.description": "Explore all changes made to sticky notes within your specified time frame.",
  "boardDiff.log.moreResults": "More results available - refine your filters or time frame to see them.",
  "boardDiff.log.title": "Log",
  "boardDiff.now": "now",
  "boardDiff.planningDates": "During PI planning event",
  "boardDiff.thisIteration": "Current Iteration",
  "boardDiff.thisPI": "Current PI ",
  "boardDiff.thisWeek": "This week",
  "boardDiff.timePickerToggle": "Time selectors",
  "boardUsers.activeMembers": "Active Members",
  "boardUsers.currentUsersOnBoard": "Current users on the board: {userNames}",
  "boardUsers.moreUsers": "+{more}",
  "boardUsers.unknown": "unknown",
  "bottomMenu.collapse": "Hide Utilities",
  "bottomMenu.expand": "Show Utilities",
  "breakdownModal.description": "Overview of all stickies linked to this item.",
  "breakdownModal.risks": "Risks",
  "breakdownModal.solution": "Solution Train",
  "breakdownModal.title": "Breakdown",
  "breakdownModal.unknown": "Unassigned",
  "breakdownModal.unplanned": "Unplanned Work",
  "cardAction.art": "ART",
  "cardAction.delete": "Delete",
  "cardAction.depend": "Depend",
  "cardAction.history": "History",
  "cardAction.mirror": "Mirror",
  "cardAction.move": "Move to Board",
  "cardAction.pin": "Pin",
  "cardAction.program": "Mirror to Planning board",
  "cardAction.project": "Project",
  "cardAction.reactions": "Reactions",
  "cardAction.remove": "Remove",
  "cardAction.share": "Share",
  "cardAction.storyPoints": "Story Points: {points}",
  "cardAction.team": "Team",
  "cardAction.unpin": "Unpin",
  "cardAction.unplan": "Unplan",
  "cardDiff.cardTitle": "Sticky Note History Log",
  "confidenceVote.active": "Active",
  "confidenceVote.anonymous": "Anonymous",
  "confidenceVote.anonymousSessionMessage": "Anonymous vote. Participants and votes are hidden",
  "confidenceVote.anonymousVote": "Anonymous vote",
  "confidenceVote.anonymousVoteDescription": "Participants and their choices will be hidden.",
  "confidenceVote.cancel": "Cancel",
  "confidenceVote.cardAriaLabel": "View {title} voting session",
  "confidenceVote.confirm": "Confirm",
  "confidenceVote.confirmDelete": "Delete this voting session?",
  "confidenceVote.confirmEndMessage": "Is everyone done? This will end the voting session for everyone!",
  "confidenceVote.createSessionFailed": "Failed to create voting session. Please try again.",
  "confidenceVote.dashboardDescription": "View and manage confidence voting sessions for your teams",
  "confidenceVote.deleteFailed": "Failed to delete session",
  "confidenceVote.deleteSession": "Delete session",
  "confidenceVote.description": "Description",
  "confidenceVote.descriptionPlaceholder": "Add a description...",
  "confidenceVote.draft": "Draft",
  "confidenceVote.draftSaveFailed": "Failed to save draft",
  "confidenceVote.draftSaved": "Saved",
  "confidenceVote.drafts": "Drafts",
  "confidenceVote.emptyStateDescription": "Start a confidence vote to gauge team sentiment and alignment during PI Planning.",
  "confidenceVote.emptyStateTitle": "No confidence votes yet",
  "confidenceVote.endAndReveal": "End & Reveal Votes",
  "confidenceVote.endSessionFailed": "Failed to end voting session. Please try again.",
  "confidenceVote.fieldTeam": "team",
  "confidenceVote.fieldTitle": "title",
  "confidenceVote.inviteToastAction": "Join",
  "confidenceVote.inviteToastMessage": "You were invited to a confidence vote",
  "confidenceVote.levelAll": "All Votes",
  "confidenceVote.levelHigh": "High\nConfidence",
  "confidenceVote.levelLow": "Low\nConfidence",
  "confidenceVote.levelMedium": "Medium\nConfidence",
  "confidenceVote.levelNoConfidence": "No\nConfidence",
  "confidenceVote.levelNotVoted": "Did Not Vote",
  "confidenceVote.levelVeryHigh": "Very High\nConfidence",
  "confidenceVote.levelVeryLow": "Very Low\nConfidence",
  "confidenceVote.loadFailed": "Failed to load voting sessions",
  "confidenceVote.noActiveSessions": "No active votes",
  "confidenceVote.noParticipants": "No participants have joined yet",
  "confidenceVote.noPastSessions": "No past votes",
  "confidenceVote.noResultsFound": "No results found",
  "confidenceVote.notInvited": "You weren't invited to this voting session and cannot vote",
  "confidenceVote.optional": "(optional)",
  "confidenceVote.overallConfidence": "Overall Confidence (Avg.)",
  "confidenceVote.participantActiveMessage": "Voting results will be visible once the vote has ended.",
  "confidenceVote.participantsVoted": "{voted}/{total} participants voted",
  "confidenceVote.pastVotes": "Past Votes",
  "confidenceVote.provideDetails": "Provide Details",
  "confidenceVote.requiredFieldsError": "Please fill in required fields: {fields}.",
  "confidenceVote.resultsOnlyVisibleToAdmin": "Voting results are visible only to you until the voting ends.",
  "confidenceVote.save": "Update",
  "confidenceVote.saveAsDraft": "Save as Draft",
  "confidenceVote.selectParticipatingTeams": "Select Participating Teams",
  "confidenceVote.sessionDeletedToast": "Session deleted",
  "confidenceVote.sessionEndedMessage": "Voting has ended. Participants can now see the results.",
  "confidenceVote.startFirstVote": "Start Your First Vote",
  "confidenceVote.startNewVote": "Create New",
  "confidenceVote.startVote": "Start Vote",
  "confidenceVote.statusEnded": "Ended",
  "confidenceVote.statusStarted": "Started",
  "confidenceVote.teamsCount": "{count} Teams | {count} Team | {count} Teams",
  "confidenceVote.title": "Confidence Vote",
  "confidenceVote.titlePlaceholder": "Title",
  "confidenceVote.voteForLevel": "Vote for {level}",
  "confidenceVote.voteSubmitFailed": "Failed to submit your vote. Please try again.",
  "confidenceVote.voted": "Voted",
  "confidenceVote.votingEnded": "Voting Ended",
  "connectionStatus.autoReconnect": "Trying to reconnect...",
  "connectionStatus.notWorking": "Network connection failed.",
  "connectionStatus.refreshPage": "Refresh page",
  "contextMenu.createNew": "Create new sticky note",
  "contextMenu.drawModeOff": "Exit Draw Mode",
  "contextMenu.drawModeOn": "Draw Lines",
  "contextMenu.general": "General",
  "contextMenu.saveBoardImage": "Save board as image",
  "contextMenu.selectedStickyCount": "Selected Stickies ({selectedCount})",
  "contextMenu.synchronizeBacklog": "Synchronize Backlog Board",
  "contextMenu.synchronizeIteration": "Synchronize iteration",
  "contextMenu.zoomToRegion": "Zoom to region",
  "date.ago": "{time} ago",
  "date.hour": "1 hour | {count} hours",
  "date.in": "in {time}",
  "date.minute": "1 minute | {count} minutes",
  "date.now": "Just now",
  "date.range": "{from} - {to}",
  "date.today": "Today",
  "date.tomorrow": "Tomorrow",
  "date.yesterday": "Yesterday",
  "depTeamFilter.all": "All",
  "depTeamFilter.all.desc": "Show dependencies where the selected team is involved | Show dependencies where any of the selected teams is involved",
  "depTeamFilter.blocked": "Blocked",
  "depTeamFilter.blocked.desc": "Show dependencies where the selected team is blocked | Show dependencies where any of the selected teams is blocked",
  "depTeamFilter.enabling": "Enabling",
  "depTeamFilter.enabling.desc": "Show dependencies where the selected team is enabling | Show dependencies where any of the selected teams is enabling",
  "depTeamFilter.mutual": "Mutual",
  "depTeamFilter.mutual.desc": "Show dependencies between the selected teams",
  "depTeamFilter.other": " ",
  "dependency.goToTeamBoard": "Go to '{team}' team board",
  "dependency.linked": "Linked",
  "dependency.notLinked": "Not Linked",
  "dependency.stickies": "Dependency Stickies",
  "dependencyChart.ariaLabel": "Sankey chart showing dependency flows between teams",
  "dependencyChart.colLabel.depend_team": "Enabling Team",
  "dependencyChart.colLabel.precond_team": "Blocked Team",
  "dependencyChart.externalArt": "External",
  "dependencyChart.flowTooltip": "1 dependency ({precondTeam} depends on {dependTeam}) | {count} dependencies ({precondTeam} depends on {dependTeam})",
  "dependencyChart.noDependencies": "No dependencies found",
  "devLinks.empty": "No merge requests",
  "devLinks.loading": "Loading…",
  "devLinks.status.declined": "Declined",
  "devLinks.status.merged": "Merged",
  "devLinks.status.open": "Open",
  "devLinks.unknownRepo": "Unknown repository",
  "flexBoardElem.confirm": "Are you sure you want to delete this canvas and all sticky notes on it?",
  "flexBoardElem.delete": "DELETE",
  "flexBoardElem.duplicate": "COPY",
  "flexBoardElem.duplicateToSession": "Select the PI session to copy to:",
  "flexModal.addCanvas": "Add Canvas",
  "flexModal.addCategory": "Add Category",
  "flexModal.all": "All",
  "flexModal.chooseCanvas": "Choose a canvas type to add",
  "flexModal.chooseDuplicateCanvas": "Choose a canvas to import",
  "flexModal.chooseDuplicateSession": "Select the PI session to copy from:",
  "flexModal.collaborationCanvas": "Collaboration Canvases",
  "flexModal.defaultCanvasName": "Board name",
  "flexModal.deleteCategoryDialog": "Are you sure you want to delete this category? \n\n The canvases in it will still be available in the 'All' category.",
  "flexModal.dragCanvases": "Drag canvases onto Categories to organize them.",
  "flexModal.duplicateCanvas": "Import Canvas",
  "flexModal.duplicated": "The canvas has been copied.",
  "flexModal.duplicatedError": "The canvas could not be copied.",
  "flexModal.manage": "Manage",
  "flexModal.newCategory": "New Category",
  "flexModal.noCanvasAsk": "There are no canvas types configured. Ask your RTE to configure them.",
  "flexModal.noCanvasConfigure": "There are no canvas types configured. Click {manage} to configure them.",
  "flexModal.noCanvasConfiguredMessage": "There are no canvases configured. Click {add} to create a new one.",
  "flexModal.unmanage": "Done",
  "flowBoard.clearFilters": "Clear Filters",
  "flowBoard.type": "Type",
  "general.about": "About",
  "general.action": "Action",
  "general.archived": "Archived",
  "general.art": "ART: {name}",
  "general.arts": "ARTs",
  "general.assigned": "Assignee: {name}",
  "general.assignee": "Assignee",
  "general.assignees": "Assignees",
  "general.board": "Board: {name}",
  "general.boards": "Boards",
  "general.cancel": "Cancel",
  "general.canvas": "Canvas: {name}",
  "general.canvasType": "Canvas type: {name}",
  "general.canvasTypes": "Canvas types",
  "general.canvases": "{type} canvases",
  "general.capacity": "Capacity",
  "general.clear": "Clear",
  "general.close": "Close",
  "general.copied": "Copied",
  "general.copy": "Copy",
  "general.delete": "Delete",
  "general.failedToLoad": "Failed to load",
  "general.infoLink": "Learn more",
  "general.iterations": "Iterations",
  "general.kanbanBoard": "Kanban Board",
  "general.label": "Label",
  "general.links": "Links",
  "general.links.count": "1 Link | {count} Links",
  "general.myWork": "Show my work",
  "general.namedArt": "ART {name}",
  "general.namedIteration": "Iteration {name}",
  "general.namedTeam": "Team {name}",
  "general.noArt": "No ART",
  "general.noAssignee": "No assignee",
  "general.noLinkedStickies": "No linked stickies",
  "general.noReporter": "Unknown creator",
  "general.noTeam": "No team",
  "general.objectives": "Objectives",
  "general.parentheses": "({value})",
  "general.partOfTotal": "{part}/{total}",
  "general.percent": "{value}%",
  "general.reporter": "Creator: {name}",
  "general.reporters": "Creators",
  "general.retry": "Retry",
  "general.select": "Select",
  "general.session": "Session: {name}",
  "general.status": "Status",
  "general.statusClass": "Status Class",
  "general.statusClasses": "Status Classes",
  "general.statuses": "Statuses",
  "general.stickers": "Stickers",
  "general.stickyTypes": "Sticky Note Types",
  "general.team": "Team: {name}",
  "general.teamDependencies": "Team dependencies",
  "general.teams": "Teams",
  "general.text": "Text",
  "general.unassigned": "Unassigned",
  "globalError.contactSupport": "If the problem persists, please contact our support.",
  "globalError.correlationId": "Correlation ID: {id}",
  "globalError.informAdmin": "If the problem persists, please inform your administrator.",
  "globalError.reloadPage": "Reload Page",
  "globalError.somethingWrong": "Something went wrong!",
  "globalError.statusPage": "status page",
  "globalError.technicalDetails": "Technical details",
  "globalError.tryCheckStatus": "Try reloading the page or check our {status}.",
  "inactiveTimer.description": "Description",
  "inactiveTimer.duration": "Duration",
  "inactiveTimer.startTimer": "Start timer",
  "issueSelector.advanced.finalQuery": "Final Query",
  "issueSelector.advanced.lastReloaded": "Last reloaded: {time}",
  "issueSelector.advanced.reload": "Reload Work Items",
  "issueSelector.alm.subtitle": "Team-level work items - Select from {almTool}",
  "issueSelector.alm.tooltip.description": "Lists issues from {almTool} in the project mapped to this piplanning.io team which are not yet in any of this team's iterations.",
  "issueSelector.alm.tooltip.hint": "Click the advanced filter button to see the JQL.",
  "issueSelector.backlog.empty": "ART-level work items assigned to your team will appear here",
  "issueSelector.backlog.subtitle": "ART-level work items - In Planning",
  "issueSelector.backlog.tooltip.description": "Lists all work items assigned to this team which are not yet visualized on this team board.",
  "issueSelector.backlog.tooltip.hint": "Works only if you have mirroring enabled for sticky types on the backlog board.",
  "issueSelector.configure": "Configuration",
  "issueSelector.disabled.multipleSources": "Issue Selector is not yet available for teams mapped to multiple projects",
  "issueSelector.disabled.noSource": "This team is not mapped to a Jira project",
  "issueSelector.filter.advanced": "Advanced Filters",
  "issueSelector.filter.assignee": "Assignee",
  "issueSelector.filter.textSearch": "Search Items",
  "issueSelector.filter.userNotMappedInAlm": "This piplanning.io account is currently not mapped to a {almType} user.",
  "issueSelector.filter.userNotMappedInPip": "The user assigned to that issue in {almType} is not known in piplanning.io.",
  "issueSelector.jql.assignee": "Selected Assignees",
  "issueSelector.jql.issuetype": "Selected Work Item Types",
  "issueSelector.jql.issuetype.default": "Work Item types allowed on this board",
  "issueSelector.jql.linked_to": "Linked to selected work items",
  "issueSelector.jql.order_by.default": "Order like in the Jira backlog",
  "issueSelector.jql.project.default": "Project configured for this board",
  "issueSelector.jql.resolution.default": "Exclude resolved work items",
  "issueSelector.jql.sprint.default": "Excludes work items in active sprints",
  "issueSelector.jql.team_fields.default": "Team mapping configured for this board",
  "issueSelector.jql.text": "Matches whole word(s) in the issue summary",
  "issueSelector.jql.text_and_issuekey": "Matches ALM ID or whole word(s) in summary",
  "issueSelector.jql.unknown": "Query segment",
  "issueSelector.limitReached": "Showing first {count} work items. There may be more. Use filters to narrow results.",
  "issueSelector.linkedTo": "Linked to",
  "issueSelector.loading": "Loading...",
  "issueSelector.message.checkConfig": "Please check the session and/or ALM configurations.",
  "issueSelector.message.noIssues": "No work items found.",
  "issueSelector.message.resetFilters": "Reset your filters.",
  "issueSelector.panelTitle": "Work Item Selector",
  "issueSelector.resetFilters": "Reset filters",
  "iterationSync.confirmManualUpdate": "Synchronize the stickies with {almType}",
  "iterationSync.failedSync": "Failed to sync iteration: {errorMessage}",
  "iterationSync.stickyOverwrite": "Stickies with ALM-Key will be overwritten by the state of {almType}.",
  "iterationSync.updateStickies": "Update Stickies",
  "kanban.found": "Columns are defined in '{board}' in {almType}",
  "kanban.multiple": "Columns are defined by sticky statuses (Multiple different kanban boards found in {almType})",
  "kanban.notAllFound": "Columns are defined by sticky statuses (Kanban boards not found for all teams in {almType})",
  "kanban.notFound": "Columns are defined by sticky statuses (No kanban board found in {almType})",
  "kanban.reloadFail": "Could not reload Kanban board configuration. Try again or inform the RTE.",
  "kanban.reloadOk": "Kanban board configuration reloaded successfully.",
  "kanban.status": "Columns are defined by sticky statuses",
  "key.alt": "Alt",
  "key.arrowDown": "Arrow Down",
  "key.arrowUp": "Arrow Up",
  "key.ctrl": "Ctrl",
  "key.enter": "Enter",
  "key.escape": "Esc",
  "key.escapeMac": "esc",
  "key.shift": "Shift",
  "key.space": "Space",
  "label.actionMenu.almIdToClipboard": "Copy ALM id",
  "label.actionMenu.almIssue": "ALM Issue (opens in new tab)",
  "label.actionMenu.almLinkToClipboard": "Copy ALM link",
  "label.actionMenu.art": "Change ART",
  "label.actionMenu.delete": "Delete Sticky",
  "label.actionMenu.depend": "Change Depend-on team",
  "label.actionMenu.duplicate": "Duplicate Sticky",
  "label.actionMenu.gitlabMRs": "Merge Requests",
  "label.actionMenu.history": "Open History Log Panel",
  "label.actionMenu.label": "Edit label",
  "label.actionMenu.link": "See Links",
  "label.actionMenu.mirror": "Mirror Sticky",
  "label.actionMenu.move": "Move Sticky",
  "label.actionMenu.pin": "Pin Sticky",
  "label.actionMenu.project": "Change Project",
  "label.actionMenu.remove": "Remove Sticky",
  "label.actionMenu.share": "Share Sticky",
  "label.actionMenu.status": "Change Status",
  "label.actionMenu.stickiesLinkToClipboard": "Copy link to stickies",
  "label.actionMenu.stickyLinkToClipboard": "Copy link to sticky | Copy link to stickies",
  "label.actionMenu.stickyType": "Change Sticky Type",
  "label.actionMenu.storyPoints": "Change Story Points",
  "label.actionMenu.team": "Change Team",
  "label.actionMenu.unplan": "Unplan Sticky",
  "label.actionMenu.wsjf": "Change WSJF Value",
  "label.artModal.description": "Choose an ART to assign the selected stickies to.",
  "label.artSelector.searchTitle": "Search by ART name.",
  "label.backlogBoardMenu": "Board Menu",
  "label.boardActions": "Board Controls",
  "label.cardDiff.cardType": "Sticky Type: {type}",
  "label.cardDiff.changedTo": "changed to:",
  "label.cardDiff.date": "Date",
  "label.cardDiff.mirrored": "This sticky note is mirrored from another board.",
  "label.flexModal.canvasDelete": "Delete Canvas {value}",
  "label.flexModal.canvasDuplicate": "Copy Canvas {value}",
  "label.flexModal.canvasEdit": "Edit Canvas {value}",
  "label.flexModal.canvases": "Canvases",
  "label.flexModal.categories": "Categories",
  "label.flexModal.categoryDelete": "Delete Category {value}",
  "label.flexModal.categoryEdit": "Edit Category {value}",
  "label.flexModal.categoryGroup": "Canvases in Category",
  "label.flexModal.categoryName": "Category Name",
  "label.flexModal.description": "Select and manage collaboration boards.",
  "label.flexModal.manage": "Manage Collaboration Canvases (opens in new tab)",
  "label.flowBoard.noFilterResults": "No items match your filters",
  "label.flowBoard.noLinkedItems": "No items linked to this work item",
  "label.flowBoard.noStickies": "No items found",
  "label.iteration.kanban": "Iteration {name} Kanban",
  "label.iteration.kebabMenu": "Iteration {name} Menu",
  "label.iteration.load": "Load: {value}",
  "label.iteration.progress": "It is {value}% of the way through the iteration.",
  "label.iterationFlag.default": "Default flag: Capacity is not set",
  "label.iterationFlag.error": "Error flag: Iteration load exceeds capacity",
  "label.iterationFlag.ok": "Ok flag: Iteration load is acceptable",
  "label.iterationFlag.warn": "Warning flag: Iteration load exceeds threshold",
  "label.linkModal.searchTitle": "Search by name.",
  "label.linkableCardRow": "{type}: {text}",
  "label.linkableCardRow.linked": "Linked {type}: {text}",
  "label.linkedOnly": "Linked only",
  "label.listItem.toggleCollapsable": "See Details",
  "label.mainLogo": "piplanning.io logo",
  "label.mainMenu.documentation": "Documentation, opens in new tab",
  "label.mainMenu.keyboardShortcuts": "Open Keyboard Shortcuts modal",
  "label.mainMenu.profile": "User Profile, opens in new tab",
  "label.mainMenu.releaseNotes": "Release notes, opens in new tab",
  "label.mainMenu.rteCockpit": "RTE Cockpit, opens in new tab",
  "label.mainMenu.settings": "Open Settings modal",
  "label.mainMenu.tutorials": "Tutorials, opens in new tab",
  "label.menuSidebar": "Board Navigation",
  "label.menuTop": "Main Navigation",
  "label.menuTop.appZoom": "Set app zoom level. Current zoom: {value}%",
  "label.menuTop.changeSession": "Change PI session",
  "label.metricsModal.art.description": "View and analyze the metrics of the {art} art.",
  "label.metricsModal.team.description": "View and analyze the metrics of the {team} team.",
  "label.mirrorModal.description": "Choose a board to mirror the selected stickies to.",
  "label.mobile.iframe": "YouTube video player",
  "label.moveSticky.controls": "Move sticky note",
  "label.moveSticky.controlsActivated": "Sticky note grabbed. Use the arrow keys to move the sticky, Spacebar to drop, Escape key to cancel.",
  "label.moveSticky.controlsDeactivated": "Sticky note dropped.",
  "label.moveSticky.edgeOfBoard": "You've reached the edge of the board.",
  "label.moveSticky.intoSection": "Sticky note moved from section {from} to section {to}.",
  "label.moveSticky.moveCancelled": "Move cancelled.",
  "label.moveSticky.moved": "{left}% from left, {top}% from top. In section {section}.",
  "label.objective": "Objective {index}: {text}",
  "label.objective.add": "Add Objective",
  "label.objective.av": "Actual value: {value}",
  "label.objective.avButton": "Actual value selector",
  "label.objective.board": "Objectives Board",
  "label.objective.bv": "Business value: {value}",
  "label.objective.bvButton": "Business value selector",
  "label.objective.menu": "Objective Menu",
  "label.objective.nextTeam": "Next Team",
  "label.objective.previousTeam": "Previous Team",
  "label.objective.summaryButton": "Objective summary: {summary}. Click to see more or edit the description.",
  "label.objective.team": "Team PI Objectives",
  "label.overviewModal.description": "Overview of stickies in the {section} section.",
  "label.overviewModal.selection": "Selected Stickies",
  "label.percentSign": "%",
  "label.percentage.decrease": "Decrease {value}",
  "label.percentage.increase": "Increase {value}",
  "label.planReadout.description": "Presentation modal, showing teams' objectives, risks and planned capacity.",
  "label.planningBoard.boardSection": "Board Section",
  "label.planningBoard.extraGroup": "Extra Row",
  "label.planningBoard.seeOverviewButton": "See Section Overview",
  "label.reaction.hot": "Hot",
  "label.reaction.increment": "Plus 1",
  "label.reaction.love": "Love",
  "label.reaction.usersNumberForReaction": "{number} users reacted with {reaction}",
  "label.resultsCount": "Showing {count} result. | Showing {count} results.",
  "label.resultsCount.currentBoard": "{count} sticky note found on the current board. | {count} sticky notes found on the current board.",
  "label.scaleStickies.bigger": "Increase sticky size",
  "label.scaleStickies.smaller": "Decrease sticky size",
  "label.search.currentBoardResults": "Results on current board",
  "label.search.filterButton": "Filter by {value}",
  "label.search.otherBoardResults": "Results on other boards (view switches to other board on selection)",
  "label.sessionSelectionModal.description": "Select a PI session",
  "label.settings.description": "Change how boards are shown to you. This will not affect other users.",
  "label.settings.fontTrigger": "Font Type Dropdown",
  "label.settings.lineupDistance": "Lineup Distance",
  "label.shortcut": "Shortcut: {value}",
  "label.shortcutsModal.description": "Keyboard shortcuts for performing various actions in the app. Note that not all shortcuts will work on all boards / pages.",
  "label.showLinkedWorkItems": "Show linked work items",
  "label.skipToBoard": "Skip to Current Board",
  "label.skipToCards": "Jump to Stickies",
  "label.skipToResults": "Skip to Results",
  "label.stickyNote": "{type}: {text}",
  "label.stickyNote.WSJFDialogDescription": "Set WSJF value for this sticky note.",
  "label.stickyNote.sticker": "Sticker: {color} {type}",
  "label.stickyNote.storyPointsDialogDescription": "Set story points for this sticky note.",
  "label.teamModal.description": "Choose a team to assign the selected stickies to.",
  "label.teamObjectives.expand": "Open team objectives modal",
  "label.teamObjectivesModal.description": "View and edit the team's objectives for this PI.",
  "label.teamSelector.searchTitle": "Search by Team name.",
  "label.timerPanel": "Timer Panel",
  "label.timerPanel.addArtTimer": "Add ART Timer",
  "label.timerPanel.addTeamTimer": "Add Team Timer",
  "label.timerPanel.durationHours": "hours",
  "label.timerPanel.durationMinutes": "minutes",
  "label.timerPanel.durationSeconds": "seconds",
  "label.timerPanel.pause": "Pause Timer",
  "label.timerPanel.resume": "Resume Timer",
  "label.timerPanel.stop": "Stop Timer",
  "label.timerPanel.timeRemaining": "Time remaining: {h} hours, {m} minutes, {s} seconds",
  "label.unlinkedOnly": "Unlinked only",
  "label.upperLevelLinks": "Links to upper level work items",
  "label.userSelector.searchTitle": "Search by User name.",
  "label.zoomIn": "Zoom In",
  "label.zoomOut": "Zoom Out",
  "license.expired": "Licenses have expired.",
  "license.expiredInDays": "Licenses expire in one day. | Licenses expire in {count} days.",
  "license.renew": "Renew licenses.",
  "linkChip.addLinks": "Add Links",
  "linkChip.directLinks": "Direct Links",
  "linkChip.itemCount": "{count} Item | {count} Items",
  "linkChip.noDependTeam": "No enabling team",
  "linkChip.noPrecondTeam": "No blocked team",
  "linkChip.storyPoints": "{points} Story Points",
  "linkModal.addLink": "Add Link to Item: {text}",
  "linkModal.art": "ART",
  "linkModal.description": "Link and unlink stickies and objectives",
  "linkModal.filterItems": "Filter Items",
  "linkModal.headerCardTarget": "Link Sticky Note(s)",
  "linkModal.headerObjectiveTarget": "Link Objective(s)",
  "linkModal.linkAnnouncement": "{kind} with text: {text} has been {action}",
  "linkModal.linked": "Linked",
  "linkModal.noItems": "No items added yet",
  "linkModal.noSearchResults": "No results found on this board or across other boards.",
  "linkModal.objective": "Objective",
  "linkModal.organization": "Organization",
  "linkModal.removeLink": "Remove Link to Item: {text}",
  "linkModal.resetFilters": "Reset filters",
  "linkModal.searchPlaceholder": "Search Items",
  "linkModal.searchResults": "Search Results",
  "linkModal.searchResultsInOtherARTs": "Search results found in other ARTs/Teams",
  "linkModal.selectedItems": "All Items | {item} | {count} Items",
  "linkModal.solutionTrain": "Solution Train",
  "linkModal.sticky": "Sticky",
  "linkModal.team": "Team",
  "linkModal.toggleOrganizationTree": "Collapse or Expand Organization Tree",
  "linkModal.unlinked": "Unlinked",
  "linkState.criticalLink.count": "1 Critical Link | {count} Critical Links",
  "linkState.criticalLinks": "Critical Links",
  "linkState.riskyLink.count": "1 Risky Link | {count} Risky Links",
  "linkState.riskyLinks": "Risky Links",
  "linkState.title": "Link states",
  "linkableCardRow.linkRemoved": "Link Removed",
  "linkableCardRow.removeLink": "Remove Link to Sticky: {card}",
  "list.menuList": "Menu List",
  "loadCapacityChart.empty": "No data",
  "loadCapacityChart.label": "Load: {load}, Capacity: {capacity}.",
  "loadCapacityChart.labelWithTitle": "{title}: Load: {load}, Capacity: {capacity}.",
  "loadCapacityChart.load": "Load",
  "loadCapacityChart.loading": "Loading",
  "loginPage.notLogin": "Could not login. Please try again.",
  "loginPageEmail.continue": "Continue",
  "loginPageEmail.email": "Email",
  "loginPageEmail.login": "Log In",
  "loginPageEmail.noAccount": "Don't have an account? {register}",
  "loginPageEmail.noAccount.register": "Register company",
  "loginPageEmail.useWorkEmail": "Use your work email to log in",
  "loginPageTenants.changeEmail": "Change email",
  "loginPageTenants.selectOrganization": "Select an organization",
  "loginPageTenants.selectOrganizationsAssociated": "Organizations associated with {email}",
  "logoutPage.description": "You are being logged out",
  "logoutPage.title": "Logging out",
  "message.almIdCopied": "The ALM id has been copied",
  "message.almLinkCopied": "The link to this ALM issue has been copied",
  "message.generateImage": "Generating image...",
  "message.lineTool": "Click & Drag to create lines on your board. You can snap the lines to the board's area lines and to lines you draw.",
  "message.multipleRegionsSelected": "Sticky Notes selected from multiple regions. Please select only one region.",
  "message.noNewlineOnAlmSynced": "Line breaks in ALM synced sticky notes are not supported",
  "message.onlyRTEAdminAllowed": "Only the admin user / RTE is allowed to change the sticky note size for the Planning Boards.",
  "message.stickyLinkCopied": "The link to this sticky has been copied | The link to these stickies has been copied",
  "metricsModal.allIterations": "All iterations combined",
  "metricsModal.allTeams": "All Teams",
  "metricsModal.burndown.actual": "Actual",
  "metricsModal.burndown.added": "Added",
  "metricsModal.burndown.chartLabel": "Burndown chart",
  "metricsModal.burndown.completed": "Completed",
  "metricsModal.burndown.end": "End",
  "metricsModal.burndown.hideNonWorkingDays": "Hide non-working days",
  "metricsModal.burndown.noData": "No burndown data available for the selected scope.",
  "metricsModal.burndown.nonWorkingDaysHidden": "Non-working days (weekends) have been excluded from this data.",
  "metricsModal.burndown.open": "Open",
  "metricsModal.burndown.reestimated": "Re-estimated",
  "metricsModal.burndown.removed": "Removed",
  "metricsModal.burndown.scope": "Timeframe",
  "metricsModal.burndown.start": "Start",
  "metricsModal.burndown.title": "Burndown",
  "metricsModal.burndown.trend": "Ideal Burndown",
  "metricsModal.burndown.wholePI": "Whole PI",
  "metricsModal.burndown.workingDaysNote": "Working days are Monday through Friday. The ideal burndown trend assumes no progress on weekends.",
  "metricsModal.byIteration": "By iteration",
  "metricsModal.capacityAllocation": "Capacity Allocation",
  "metricsModal.capacityAllocation.items": "Items: {value}",
  "metricsModal.capacityAllocation.points": "Points: {value}",
  "metricsModal.dependencies": "Dependencies",
  "metricsModal.export.allIterations": "All Iterations",
  "metricsModal.export.allTeams": "All Teams",
  "metricsModal.export.button": "Export",
  "metricsModal.export.copied": "Copied",
  "metricsModal.export.copyForAi": "Copy for AI",
  "metricsModal.export.csv": "Export as CSV",
  "metricsModal.export.date": "Date",
  "metricsModal.export.description.burndown": "This is Burndown data from a SAFe PI Planning session. Each row is one day showing open work remaining and daily changes. Completed items reduce the open count; Added items are new scope; Removed items left scope; Re-estimated reflects point changes on existing items. The ideal burndown is a steady decline from start to zero by the end date. Scope increases (Added) or re-estimation spikes indicate mid-PI changes worth investigating.",
  "metricsModal.export.description.capacityAllocation": "This is Capacity Allocation data from a SAFe PI Planning session. It shows how each team's planned work is distributed across work item types (e.g., Features, Enablers, Defects). The percentage is relative to the team's total planned load. SAFe recommends teams maintain a healthy balance — typically investing enough in Enablers (technical work) to sustain long-term velocity, while prioritizing Features (business value) and keeping Defects low.",
  "metricsModal.export.description.dependencies": "This is a Dependencies chart from a SAFe PI Planning session. Each row represents a dependency between two teams: the Blocked Team needs something from the Enabling Team. The Dependencies column shows how many individual dependency links exist between that pair. High dependency counts between teams indicate tight coupling and coordination risk. Look for teams with many incoming dependencies (bottlenecks) or many bi-directional dependencies.",
  "metricsModal.export.description.loadCapacity": "This is Load vs Capacity data from a SAFe PI Planning session. Load is the total story points of planned work. Capacity is the team's available effort for the iteration/PI. Utilization = Load / Capacity. Under 100% means the team has spare capacity; over 100% means the team is overcommitted. Look for teams that are significantly over- or under-loaded, and consider whether work should be redistributed.",
  "metricsModal.export.description.predictability": "This is Value Predictability data from a SAFe PI Planning tool, tracked across multiple PI sessions. Each value is a percentage representing the ratio of achieved business value to planned business value for team objectives. A score of 100% means the team delivered exactly what they committed to. SAFe considers 80%-100% a healthy range. Below 80% suggests overcommitment or delivery issues; above 100% suggests undercommitment. Trends over time reveal whether teams are improving their forecasting accuracy.",
  "metricsModal.export.failed": "Export failed",
  "metricsModal.export.footer": "Exported from piplanning.io on {date}",
  "metricsModal.export.header.blockedTeam": "Blocked Team",
  "metricsModal.export.header.blockedTeamArt": "Blocked Team ART",
  "metricsModal.export.header.capacity": "Capacity",
  "metricsModal.export.header.dependencies": "Dependencies",
  "metricsModal.export.header.enablingTeam": "Enabling Team",
  "metricsModal.export.header.enablingTeamArt": "Enabling Team ART",
  "metricsModal.export.header.iteration": "Iteration",
  "metricsModal.export.header.load": "Load",
  "metricsModal.export.header.percentSuffix": "{name} %",
  "metricsModal.export.header.session": "Session",
  "metricsModal.export.header.team": "Team",
  "metricsModal.export.header.total": "Total",
  "metricsModal.export.header.utilization": "Utilization",
  "metricsModal.export.label.art": "ART",
  "metricsModal.export.label.session": "Session",
  "metricsModal.export.label.team": "Team",
  "metricsModal.export.note.capacityAllocation.count": "The numbers given are the number of work items. They may differ in actual work size.",
  "metricsModal.export.note.capacityAllocation.points": "The numbers given are story points.",
  "metricsModal.export.png": "Export as PNG",
  "metricsModal.export.unassigned": "Unassigned",
  "metricsModal.export.unknown": "Unknown",
  "metricsModal.filters.button": "Filters",
  "metricsModal.filters.externalTeamsOnly": "External teams only",
  "metricsModal.loadVsCapacity": "Load vs. Capacity",
  "metricsModal.predictability.art": "ART Predictability",
  "metricsModal.predictability.artAverage": "ART Performance",
  "metricsModal.predictability.description1": "Shows the ratio of Actual Business Value (AV) to Planned Business Value (BV) achieved by teams, per PI.",
  "metricsModal.predictability.description2": "The healthy range is {start} - {end}.",
  "metricsModal.predictability.description3": "Above {end} indicates under-committing; below {start} indicates over-committing.",
  "metricsModal.predictability.goToObjectives": "Go to Objectives Board",
  "metricsModal.predictability.healthyEnd": "100%",
  "metricsModal.predictability.healthyStart": "80%",
  "metricsModal.predictability.includeArchived": "Include archived sessions",
  "metricsModal.predictability.latestArt": "Latest ART Predictability",
  "metricsModal.predictability.latestLabel": "{label}: ",
  "metricsModal.predictability.latestTeam": "Latest Team Predictability",
  "metricsModal.predictability.missingAvWarning": "Some objectives are missing Actual Value (AV) data, which may affect accuracy.",
  "metricsModal.predictability.noValues": "No predictability values recorded yet. To start tracking, assign Planned Business Value (BV) to your team objectives and record Actual Business Value (AV) after each PI.",
  "metricsModal.predictability.overcommitting": "Over-committing",
  "metricsModal.predictability.targetRange": "Healthy Range (80–100%)",
  "metricsModal.predictability.team": "Team Predictability",
  "metricsModal.predictability.tooltipNoValue": "{team}: N/A",
  "metricsModal.predictability.tooltipValue": "{team}: {value}%",
  "metricsModal.predictability.undercommitting": "Under-committing",
  "metricsModal.predictability.unknownTeam": "Team {id}",
  "metricsModal.predictability.valuePercent": "{value}%",
  "metricsModal.predictability.yAxisLabel": "Actual vs Planned Value Ratio (%)",
  "metricsModal.storyPoints": "Story Points",
  "metricsModal.workItemCount": "Work Item Count",
  "metricsModal.workUnit": "Metric",
  "mirrorModal.title": "Mirror stickies to board",
  "mobileInfo.askIfOnDesktop": "Are you on desktop instead?",
  "mobileInfo.checkVideo": "Check out the video below to see why it is designed for desktop only",
  "mobileInfo.chooseDevice": "Choose your device",
  "mobileInfo.loginBlurb": "Click here to log in",
  "mobileInfo.loginFromDesktop": "Log in from your desktop device",
  "mobileInfo.onDesktop": "I'm on Desktop",
  "mobileInfo.onMobile": "I'm on Mobile",
  "mobileInfo.userExperienceBlurb": "For the best user experience choose the device that you are currently using",
  "modal.capacityValue": "Capacity: {capacity}",
  "modal.loadValue": "Load: {number}",
  "mouse.doubleClick": "Double click",
  "multiLineStickyCreate.multi": "Create a sticky note per line",
  "multiLineStickyCreate.one": "Create one sticky note",
  "multiLineStickyCreate.text": "The text to be pasted contains multiple lines",
  "objective.deleted": "Objective deleted",
  "objective.markAsCommitted": "Mark as committed",
  "objective.markAsUncommitted": "Mark as uncommitted",
  "objective.moveDown": "Move Down",
  "objective.moveUp": "Move Up",
  "objectives.actualValue": "Actual Value",
  "objectives.add": "Objective",
  "objectives.av": "AV",
  "objectives.businessValue": "Business Value",
  "objectives.bv": "BV",
  "objectives.committed": "Committed",
  "objectives.count": "1 Objective | {count} Objectives",
  "objectives.description.placeholder": "Add a description",
  "objectives.hideDescriptionButton": "Hide Description",
  "objectives.none": "No objectives yet",
  "objectives.programObjectives": "ART PI Objectives",
  "objectives.rag": "RAG",
  "objectives.rag.amber": "Amber",
  "objectives.rag.green": "Green",
  "objectives.rag.red": "Red",
  "objectives.showDescriptionButton": "Show Description",
  "objectives.title.placeholder": "Title",
  "objectives.uncommitted": "Uncommitted",
  "objectivesBoard.objectives": "{name} PI Objectives",
  "objectivesModal.add": "Add",
  "objectivesModal.linkedStickies": "Linked stickies",
  "objectivesModal.linkedStickiesNumber": "1 linked sticky note | {count} linked sticky notes",
  "onboarding.creatingSession": "Creating your session...",
  "onboarding.creatingSubtitle": "We're populating your session with sample data so you can explore every feature",
  "onboarding.demoDescription": "Pick a template to get started with a pre-configured session",
  "onboarding.error.message": "We couldn't set up the sample data. You can try again or start with an empty session instead.",
  "onboarding.error.title": "Something went wrong",
  "onboarding.error.tryAgain": "Try again",
  "onboarding.loadingTemplates": "Loading templates...",
  "onboarding.mobileGate.actionDetail": "Open it on a laptop or desktop to get started.",
  "onboarding.mobileGate.actionTitle": "We just emailed you a link",
  "onboarding.mobileGate.headline": "Your session is ready",
  "onboarding.mobileGate.reasons.boards": "Zoom across program-wide canvases",
  "onboarding.mobileGate.reasons.dependencies": "Trace dependencies across teams",
  "onboarding.mobileGate.reasons.stickies": "Drag, group, and link stickies",
  "onboarding.mobileGate.subhead": "But planning needs a real keyboard and screen.",
  "onboarding.setupLearningSession": "Welcome! Let's explore PI Planning together",
  "onboardingGuide.contactCta.title": "Talk to Our Team",
  "onboardingGuide.dependencies.description": "Surface and track dependencies across teams in real time.",
  "onboardingGuide.dependencies.title": "Keep dependencies under control",
  "onboardingGuide.description": "Choose how you want to start",
  "onboardingGuide.dismiss": "I just want to explore",
  "onboardingGuide.getReady.description": "Start a guided setup and get ready for your first PI Planning event.",
  "onboardingGuide.getReady.title": "Set up your own PI Planning",
  "onboardingGuide.introVideo.title": "Watch intro video",
  "onboardingGuide.leadPlanning.description": "Align teams quickly and guide planning from kickoff to commitments.",
  "onboardingGuide.leadPlanning.title": "PI Planning without the chaos",
  "onboardingGuide.menuTooltip": "Access the tutorials here at any time",
  "onboardingGuide.navigation.title": "Take a quick tour",
  "onboardingGuide.planAcross.description": "Coordinate teams and ARTs in one clear, shared plan.",
  "onboardingGuide.planAcross.title": "Scale your planning without losing alignment",
  "onboardingGuide.recommended": "Recommended",
  "onboardingGuide.title": "Let's get you ready for PI Planning",
  "onboardingWelcome.continue": "Get Started",
  "onboardingWelcome.description": "Watch this short video to get started with your first PI Planning session",
  "onboardingWelcome.replay": "Replay video",
  "onboardingWelcome.skip": "Skip Intro",
  "onboardingWelcome.title": "Welcome to piplanning.io",
  "onboardingWelcome.videoTitle": "Getting started with piplanning.io",
  "overviewModal.title": "Overview",
  "page.login": "Login",
  "page.onboard": "Get Started | piplanning.io",
  "page.status": "Connection Status",
  "page.team": "Select Team",
  "planReadout.title": "Plan Readout",
  "planReadoutModal.listFooter.objectives": "Use {icons} to skip through objectives",
  "planReadoutModal.listFooter.risks": "Use {icons} to skip through risks",
  "planReadoutModal.objectives.businessValue": "Business Value: {num}",
  "planReadoutModal.objectives.indexPlaceholder": "#{index}",
  "planReadoutModal.objectives.noDescription": "No description",
  "planReadoutModal.objectives.title": "{teamName} Objectives",
  "planReadoutModal.risks": "Risks",
  "planReadoutModal.risks.count": "1 Risk | {count} Risks",
  "planReadoutModal.risks.title": "{teamName} Risks",
  "programBoard.inPlanning": "In Planning",
  "programBoard.milestoneEvents": "Milestones Events",
  "programBoard.otherArts": "Other ARTs",
  "reaction.with": "Reacted with {reaction}",
  "risk.accepted": "Accepted",
  "risk.accepted.short": "A",
  "risk.mitigated": "Mitigated",
  "risk.mitigated.short": "M",
  "risk.owned": "Owned",
  "risk.owned.short": "O",
  "risk.resolved": "Resolved",
  "risk.resolved.short": "R",
  "risk.roam": "ROAM",
  "risk.roam.ariaLabel": "ROAM: {riskTypeName}",
  "risk.roam.ariaLabel.notSet": "Not set",
  "risk.unRoam": "unROAM",
  "risk.unRoam.short": " ",
  "riskBoardLocation.submissions": "Risk Submissions",
  "searchItem.hideSearch": "Keep Filters & Close",
  "searchResults.noResults": "No results found",
  "searchResults.resultsBoards": "Search results found on other boards",
  "searchResultsTs.results": "1 result | {count} results",
  "searchResultsTs.stickies": "1 sticky note | {count} sticky notes",
  "sessionSelectionModal.isExecuting": "in Execution",
  "sessionSelectionModal.isPlanning": "in Planning",
  "sessionSelectionModal.noSessions": "You are not assigned to any PI session. Please try to reload the page or contact your administrator.",
  "sessionSelectionModal.search": "Search PI sessions",
  "sessionSelectionModal.showArchived": "Show archived sessions",
  "sessionSelectionModal.title": "Select a PI session",
  "settings.boardsTitle": "Boards",
  "settings.deviceAutoDescription": "Adapts automatically to your input device",
  "settings.deviceAutoTitle": "Auto",
  "settings.deviceMousePan": "Right click and drag",
  "settings.deviceMousePan2": "{key} + left click and drag",
  "settings.deviceMouseTitle": "Mouse",
  "settings.deviceMouseZoom": "Mouse wheel",
  "settings.devicePadPan": "Swipe with two fingers",
  "settings.devicePadTitle": "Trackpad",
  "settings.devicePadZoom": "{key} + swipe with two fingers",
  "settings.devicePadZoom2": "Pinch",
  "settings.effectiveInputWarning": "We're having trouble determining if you're using a mouse or a trackpad. Please select your input device manually.",
  "settings.effectiveInputWarning.button": "Select input device",
  "settings.fontType": "Font",
  "settings.highContrastTitle": "High-Contrast Mode",
  "settings.highlightDoneLinksDescription": "In execution mode, dependency lines to the Blocked team turn green on ART and Solution Planning Boards when all linked work items from the Enabling team are done.",
  "settings.highlightDoneLinksSubtitle": "Highlight completed dependencies",
  "settings.inputDeviceTitle": "Input device",
  "settings.lineupDistanceDescription": "The distance stickies have from each other when using the 'Line up in a grid' function.",
  "settings.lineupDistanceTitle": "Line up in a grid",
  "settings.linkLinesDescription": "Normally, they are only shown for active / highlighted stickies.",
  "settings.linkLinesSubtitle": "Show link lines permanently on Team / Canvas / Risk Board",
  "settings.linkProgramLinesSubtitle": "Show link lines permanently on ART Planning Board",
  "settings.markIterationsWithOverload": "Mark iterations with overload on the ART Planning Board.",
  "settings.overloadOnProgramBoard": "Overload on ART Planning Board",
  "settings.pan": "Move the board",
  "settings.selectionTitle": "Sticky Selection",
  "settings.settings": "Settings",
  "settings.stackDistanceDescription": "The distance stickies have from each other when using the 'Stack' function.",
  "settings.stackDistanceTitle": "Stack",
  "settings.stickyNoteTextAlignment": "Text alignment",
  "settings.stickyNoteTextAlignment.center": "Center",
  "settings.stickyNoteTextAlignment.left": "Left",
  "settings.stickyNoteTextAlignment.right": "Right",
  "settings.stickyNoteTextAlignment.triggerLabel": "Text alignment dropdown",
  "settings.stickyNotesDescription": "You can add handwriting feeling to your stickies! ☺",
  "settings.stickyNotesTitle": "Sticky Notes",
  "settings.zoom": "Zoom",
  "shape.line": "Line",
  "shortcutsModal.action.drag": "{action} Drag",
  "shortcutsModal.actionHoverOverSticky": "{action} Hover over sticky",
  "shortcutsModal.addingTeamBoardLink": "Add Team Board link",
  "shortcutsModal.alternative": "{action1} or {action2}",
  "shortcutsModal.canvasName": "canvas-name",
  "shortcutsModal.emojiId": "emoji-id",
  "shortcutsModal.emojis": "Emoji Text Format",
  "shortcutsModal.focusSticky": "Focus Item",
  "shortcutsModal.focusSticky.shortcut": "Double click on sticky",
  "shortcutsModal.general.closeDropdown": "Close Dropdown",
  "shortcutsModal.general.closeOverlay": "Close Overlay",
  "shortcutsModal.general.closeSearch": "Close Search",
  "shortcutsModal.general.fullScreen": "Full Screen Mode",
  "shortcutsModal.general.panMode": "Pan Mode",
  "shortcutsModal.link": "Add URL link",
  "shortcutsModal.linkToCanvas": "Add Canvas link",
  "shortcutsModal.newLine": "New Line (Only when not synced to an ALM tool)",
  "shortcutsModal.newStickyObjective": "New sticky note / objective",
  "shortcutsModal.pointer": "Pointer  ",
  "shortcutsModal.pressing": "Pressing {key}",
  "shortcutsModal.rightClick": "Right Click",
  "shortcutsModal.stickies.addBoardLink": "Add Board Link",
  "shortcutsModal.stickies.addBoardLink.shortcut": "#board-name",
  "shortcutsModal.stickies.copy": "Copy",
  "shortcutsModal.stickies.duplicateMouse": "Copy",
  "shortcutsModal.tab.general": "General",
  "shortcutsModal.tab.stickies": "Sticky Notes",
  "shortcutsModal.tab.tools": "Tools",
  "shortcutsModal.teamName": "team-name",
  "shortcutsModal.title": "Shortcuts",
  "shortcutsModal.tools.magnifierMode": "Magnifier Mode",
  "statusClass.done": "Done",
  "statusClass.inProgress": "In Progress",
  "statusClass.toDo": "To Do",
  "statusClass.unknown": "Unknown",
  "statusClass.votingInProgress": "Voting in Progress",
  "statusDistribution.clickForDetails": "Click on progress bar to see more details",
  "statusDistribution.emptyArt": "This art has no work items.",
  "statusDistribution.emptyIteration": "No work items in this iteration.",
  "statusDistribution.emptyObjective": "No work items are linked to this objective.",
  "statusDistribution.emptySticky": "No work items are linked to this sticky note.",
  "statusDistribution.emptyTeam": "This team has no work items.",
  "statusDistribution.highlightStickies": "Highlight stickies",
  "statusDistribution.iteration": "Day {day} of {total} in iteration",
  "statusDistribution.iteration.ended": "Iteration has ended",
  "statusDistribution.iteration.notStarted": "Iteration has not started",
  "statusDistribution.storyPoints": "Story Points",
  "statusDistribution.today": "Today: {today}",
  "statusDistribution.workItems": "Work items",
  "statusPage.descriptionCloud": "We're going to try connecting to a few different services to help diagnose any connection issues you might be having. Below, you'll see how long it takes to get a response from the piplanning.io servers (using either websockets or HTTP), as well as from Google (for reference).",
  "statusPage.descriptionOnPrem": "We're going to try connecting to a few different services to help diagnose any connection issues you might be having. Below, you'll see how long it takes to get a response from the piplanning.io server (using either websockets or HTTP).",
  "statusPage.descriptionPart2": "On the left, you'll see the response times for lightweight requests. On the right, the responses include a larger payload - note that these requests will be sent less frequently.",
  "statusPage.errorDetails": "Error Details",
  "statusPage.google": "Google (HTTP)",
  "statusPage.hidden": "Tab Inactive",
  "statusPage.hiddenExplanation": "A grey background indicates that the browser was inactive when the requests were sent.",
  "statusPage.http": "piplanning.io (HTTP)",
  "statusPage.http1mb": "HTTP (1MB)",
  "statusPage.http2mb": "HTTP (2MB)",
  "statusPage.http500kb": "HTTP (500kB)",
  "statusPage.loggedIn": "Logged In",
  "statusPage.no": "No",
  "statusPage.online": "Online",
  "statusPage.payloadTitle": "Request with Payload (piplanning.io servers)",
  "statusPage.payloadTitleShort": "Request with Payload",
  "statusPage.pingTitle": "Simple Request (ping)",
  "statusPage.reqTime": "Request sent (GMT)",
  "statusPage.responseData": "Response Data (pings)",
  "statusPage.responseTime": "Response Time",
  "statusPage.timeMs": "{time} ms",
  "statusPage.unknownError": "Unknown error",
  "statusPage.ws": "piplanning.io (WS)",
  "statusPage.ws500kb": "WS (500kB)",
  "statusPage.yes": "Yes",
  "stickerPicker.noSticker": "No sticker",
  "stickerPicker.search": "Search stickers",
  "stickerPicker.title": "Sticker",
  "stickyChange.almId": "{user} changed the ALM ID",
  "stickyChange.almId.field": "ALM ID",
  "stickyChange.almId.new": "{user} set the ALM ID",
  "stickyChange.assignee": "{user} updated the assignee",
  "stickyChange.assignee.field": "Assignee",
  "stickyChange.assignee.new": "{user} set the assignee",
  "stickyChange.created": "{user} created this sticky note",
  "stickyChange.created.field": "Creation",
  "stickyChange.deleted": "{user} deleted this sticky note",
  "stickyChange.deleted.field": "Deletion",
  "stickyChange.empty": "This sticky note's activities are not available.",
  "stickyChange.enabling": "{user} updated the enabling team",
  "stickyChange.enabling.field": "Enabling team",
  "stickyChange.enabling.new": "{user} set the enabling team",
  "stickyChange.filterByChangeType": "Filter Items by change type",
  "stickyChange.flag": "{user} changed the sticker",
  "stickyChange.flag.field": "Sticker",
  "stickyChange.flag.new": "{user} set the sticker",
  "stickyChange.incomplete": "Older activities are not available.",
  "stickyChange.iteration": "{user} changed the iteration",
  "stickyChange.iteration.field": "Iteration",
  "stickyChange.iteration.new": "{user} set the iteration",
  "stickyChange.link": "{user} added a link",
  "stickyChange.link.field": "Link",
  "stickyChange.linkedStickyNotFound": "The linked sticky note could not be found - it may have been deleted.",
  "stickyChange.mirror.field": "Mirror",
  "stickyChange.mirrored": "{user} mirrored this sticky note",
  "stickyChange.reactions": "{user} reacted to this sticky note",
  "stickyChange.reactions.field": "Reactions",
  "stickyChange.reporter": "{user} updated the creator",
  "stickyChange.reporter.field": "Creator",
  "stickyChange.reporter.new": "{user} set the creator",
  "stickyChange.risk": "{user} ROAMed this sticky note",
  "stickyChange.risk.field": "Risk",
  "stickyChange.risk.new": "{user} ROAMed this sticky note",
  "stickyChange.selectedItems": "Change Types | {item} | {count} Items",
  "stickyChange.status": "{user} changed the status",
  "stickyChange.status.field": "Status",
  "stickyChange.status.new": "{user} set the status",
  "stickyChange.stickyType": "{user} changed the sticky note type",
  "stickyChange.stickyType.field": "Type",
  "stickyChange.stickyType.new": "{user} set the sticky note type",
  "stickyChange.storyPoints": "{user} changed the story points",
  "stickyChange.storyPoints.field": "Story points",
  "stickyChange.storyPoints.new": "{user} set the story points",
  "stickyChange.summary": "{user} changed the summary",
  "stickyChange.summary.field": "Summary",
  "stickyChange.summary.new": "{user} added the summary",
  "stickyChange.team": "{user} changed the team",
  "stickyChange.team.field": "Team",
  "stickyChange.team.new": "{user} set the team",
  "stickyChange.unknownUser": "Unknown User",
  "stickyChange.unlink": "{user} removed a link",
  "stickyChange.unmirrored": "{user} removed this sticky note from",
  "stickyChange.updated": "{user} changed this sticky note",
  "stickyChange.wsjf": "{user} changed the WSJF value",
  "stickyChange.wsjf.field": "WSJF value",
  "stickyChange.wsjf.new": "{user} set the WSJF value",
  "stickyDiff.created": "This sticky note was created",
  "stickyDiff.deleted": "This sticky note was deleted",
  "stickyNote.changeTypeDependencyNotAllowed": "The type of dependency sticky notes cannot be changed",
  "stickyNote.changeTypeOnlyOriginBoard": "The type can only be changed on the {board}",
  "stickyNote.stickyType": "Sticky Type",
  "stickyStatus.status": "Status",
  "stickyType.unknown": "Unknown",
  "stickyTypeChange.nonOriginTypeDisabled": "This type belongs to another board. Create a new sticky instead.",
  "switchSession.title": "Change PI session",
  "teamBoardLocation.risks": "Risks",
  "teamModal.title": "Assign stickies to team",
  "teamObjectives.expand": "Expand Objectives",
  "teamObjectives.teamObjectives": "Team Objectives",
  "teamObjectivesModal.objectives": "{teamName} Objectives",
  "textarea.lengthIndicator": "{textLength} / {maxLength}",
  "textarea.lengthIndicator.aria": "Character count",
  "textarea.seeLess": "See less",
  "textarea.seeMore": "See more",
  "timer.add": "Add",
  "timer.addMinute": "+{m}m",
  "timer.addMinuteAria": "Add {m} minutes",
  "timer.ariaDuration": "Running Timer: {h} hours, {m} minutes, {s} seconds",
  "timer.hour": "h",
  "timer.longDuration": "{h}h {m}m {s}s",
  "timer.minute": "m",
  "timer.missingDescription": "Please set a description",
  "timer.missingDuration": "Please set a duration",
  "timer.nameLabel": "Name",
  "timer.second": "s",
  "timer.shortDuration": "{m}m {s}s",
  "timer.thisArt": "Set timer for the ART",
  "timer.thisBoard": "Set timer for this board",
  "timer.timerMessage": "Time is up!",
  "timer.title": "Timer",
  "treeView.art": "ART",
  "treeView.solutionTrain": "Solution Train",
  "userAction.documentation": "Documentation",
  "userAction.gotoProfileSync": "Go to profile",
  "userAction.keyboardShortcuts": "Keyboard shortcuts",
  "userAction.logOut": "Log Out",
  "userAction.mainMenu": "Main Menu",
  "userAction.profile": "Profile",
  "userAction.releaseNotes": "Release notes",
  "userAction.rteCockpit": "RTE Cockpit",
  "userAction.settings": "Settings",
  "userAction.tutorials": "Tutorials",
  "userAction.userNotSynced": "Your piplanning.io account is currently not linked with your {almType} account. Go to your profile to connect them.",
  "userAgreement.base": "By continuing, you agree to our {termsOfService} and acknowledge you've read our {privacyPolicy}.",
  "userAgreement.privacyPolicy": "Privacy Policy",
  "userAgreement.termsOfService": "Terms of Service",
  "version.info": "Version: {id} {hash} {time} UTC"
}
